/* template */
<template minapp="mpx" xlang="wxml"><customer-service :content="(content)" :titleKey="(question)" :listKey="(answers)" :phone="(actionTitle)" :globalPhone="(globalPhone)"/></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m1ce07dda"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m1ce07dda"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./service.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./service.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m1ce07dda"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'customer-service':getComponent(require("../../material/template/service/index.mpx?isComponent&outputPath=components%2Findex3a62f3e2%2Findex")),'HelpDeskChat':getComponent(require("../../../node_modules/@didi/spring-ui/help-desk-chat/index.mpx?isComponent&outputPath=components%2Findex047c6ed7%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
